export enum AssetStatus {
  NoStatus = -1,
  Disabled = 0,
  Closed = 1,
  Open = 2,
  Preparation = 3,
  Free = 7,
  Full = 8,
}
